'use strict';

var Backbone = require('backbone/backbone');
var _ = require('underscore/underscore');

require('./IndexSection.less');


module.exports = Backbone.View.extend({

    el: '.IndexSection',

    ANIMATION_DURATION: 1300,
    ANIMATION_TIMEOUT: 0,


    baseEvents: {
    },


    initialize: function (options) {
        this.options = options;

        //_.bindAll(this, );
    },


    getResources: function() {
        return this.resources || {};
    },


    setResources: function(resources) {
        this.resources = resources;
    },


    show: function(params) {
        params = params || {};

        var duration = params.noAnimation ? 0 : this.ANIMATION_DURATION;
        var zindex = params.isMoving ? 'above' : 'below';

        this.$el
            .show()
            .attr('data-position', params.direction)
            .attr('data-zindex', zindex)
            .attr('data-tp', 'show');

        if (duration && params.isMoving) {
            this.$el.addClass('IndexSection--notransitions'); //for ie & edge
            this.$el.outerHeight();
            this.$el.removeClass('IndexSection--notransitions');//for ie & edge
        }

        this.$el.attr('data-position', '');

        setTimeout(function() {
            this.$el
                .attr('data-zindex', '')
                .attr('data-tp', '');
            params.animationEndCallback && params.animationEndCallback();
        }.bind(this), duration + this.ANIMATION_TIMEOUT);
    },


    hide: function(params) {
        params = params || {};

        var duration = params.noAnimation ? 0 : this.ANIMATION_DURATION;
        var zindex = params.isMoving ? 'below' : 'above';

        this.$el
            .attr('data-zindex', zindex)
            .attr('data-tp', 'hide');

        if (duration && params.isMoving) {
            this.$el.outerHeight();
        }

        this.$el.attr('data-position', params.direction);

        setTimeout(function() {
            this.$el
                .attr('data-position', '')
                .attr('data-zindex', '')
                .attr('data-tp', '')
                .hide();
            params.animationEndCallback && params.animationEndCallback();

            this.onHideEnd(params);
        }.bind(this), duration + this.ANIMATION_TIMEOUT);
    },


    onHideEnd: function() {

    },


    destroy: function () {
    }
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/app/components/IndexSection/IndexSection.js
 ** module id = 8
 ** module chunks = 0
 **/